import BaseResource from './BaseResource';

export default class CommentResource extends BaseResource {
  static urlRoot = '/api/v2/comments';

  static forStory(id) {
    return {
      commentable_type: 'Story',
      commentable_id: id,
      top_level: true
    };
  }

  id = null;

  body = '';

  parentId = null;

  authorable = {};

  resolved = 0;

  get author() {
    return this.authorable;
  }

  pk() {
    return this.id;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/resources/CommentResource.js